module.exports = __webpack_public_path__ + "img/doll-elbow.98c55efb.svg";